import {FaSpinner } from "react-icons/fa"

const Loader = ({className = ""}) => 
  <FaSpinner className={`icon-spin ${className}`} />

export default Loader;